var counter = 0;
export default (function () {
    counter += 1;
    return counter;
});
